// const createVignetteBackground = require('three-vignette-background');
import "./OrbitControls";
import loader from './loader';
import ResultState from './resultState';
import PlaceState from './placeState';
import UnplaceState from './unplaceState';
import Line from './line';

require('three/examples/js/loaders/GLTFLoader');
require('three/examples/js/loaders/DRACOLoader');
require('three/examples/js/pmrem/PMREMGenerator.js');
require('three/examples/js/pmrem/PMREMCubeUVPacker.js');
require('three/examples/js/lights/LightProbeGenerator.js');

const THREE = window.THREE;

const prefix = process.env.NODE_ENV == 'production' ? "//infishwaibao.oss-cn-chengdu.aliyuncs.com/zyyzhenjiu/":"";


class Demo{
    constructor() {

        this.distLine = new Line( this );
    }

    deinit()
    {
        this.el.removeChild( this.renderer.domElement );
        this.el = null;
        if( this.loopid ) {
            cancelAnimationFrame( this.loopid );
            this.loopid = null;
        }
        this.enable = false;

        this.distLine.deinit();
    }


    init(el, cb){
        this.enable = true;

        if( this.inited ) {
            this.el = el;
            this.el.appendChild( this.renderer.domElement );
            this.loopid = requestAnimationFrame( this.animate );

            this.initModelState( this.loader );
            cb && cb();
            return;
        }
        this.inited = true;
        Line.loadFont();
        
       

        this.el = el;

        this.scene = new THREE.Scene();
        const fov = 60;
        this.defaultCamera = new THREE.PerspectiveCamera( fov, el.clientWidth / el.clientHeight, 0.00005, 50 );
        this.activeCamera = this.defaultCamera;
        this.scene.add( this.defaultCamera );

        this.scene2 = new THREE.Scene();
        // this.scene2.add( this.defaultCamera );

        this.renderer = window.renderer = new THREE.WebGLRenderer({antialias: true, alpha: true});
        // this.renderer.physicallyCorrectLights = true;
        this.renderer.gammaOutput = true;
        // this.renderer.gammaFactor = 2.2;
        this.renderer.setClearColor( 0xcccccc, 0);
        this.renderer.setPixelRatio( window.devicePixelRatio );
        this.renderer.setSize( el.clientWidth, el.clientHeight );

        this.controls = new THREE.OrbitControls( this.defaultCamera, this.renderer.domElement );
        this.controls.autoRotate = false;
        this.controls.autoRotateSpeed = -10;
        this.controls.screenSpacePanning = true;

        this.el.appendChild(this.renderer.domElement);
        this.canvas = this.renderer.domElement;

        this.cameraCtrl = null;
        this.cameraFolder = null;
        this.animFolder = null;
        this.animCtrls = [];
        this.morphFolder = null;
        this.morphCtrls = [];
        this.skeletonHelpers = [];
        this.gridHelper = null;
        this.axesHelper = null;
        this.tempVec3 = new THREE.Vector3();
        
       

        this.animate = this.animate.bind(this);
        this.loopid = requestAnimationFrame( this.animate );

        window.addEventListener('resize', this.resize.bind(this), false);

        this.mouseMove = this.onDocumentMouseMove.bind(this);
        this.canvas.addEventListener( 'mousemove', this.mouseMove, false );


        this._canvasMouseDown = (event)=>{
            if( !this.enable ) return;

            this.startX = event.clientX;
            this.startY = event.clientY;
            this.startTime = Date.now();
        }
        this.canvas.addEventListener("mousedown", this._canvasMouseDown);
        this._canvasMouseUp = (event)=>{
            if( !this.enable ) return;

            let x = event.clientX - this.startX;
            let y = event.clientY - this.startY;
            let d = Date.now() - this.startTime;
            if( Math.abs(x) < 2 && Math.abs(y) < 2 && d < 400 ){
                this.onClickCanvas(event);
            }
        }
        this.canvas.addEventListener("mouseup", this._canvasMouseUp);

        this.mouse = {x:0,y:0};
       
        loader.loadScene(this.renderer, this).then(out=>{
            console.log( out );

            //隐藏相关对象
            this.initModelState( out );

            this.setContent( out.root );
            cb && cb();
        });

        this.distLine.init();
    }
    initModelState(out){
        out.models['box.glb'].visible = false;
        out.models['aijiu_DD.glb'].visible = false;
        out.models['zhen_DaChangYu.glb'].visible = false;
        out.models['zhen_SanYinJiao.glb'].visible = false;
        out.models['zhen_TianShu.glb'].visible = false;
        out.models['zhen_ShangJuXu.glb'].visible = false;
        out.models['zhen_taichong.glb'].visible = false;
        out.models['zhen_qimen.glb'].visible = false;
        out.models['aiji_1.glb'].visible = false;
        out.models['zhen_05.glb'].visible = false;
        out.models['zhen_10.glb'].visible = false;
        out.models['zhen_15.glb'].visible = false;
        out.models['zhen_25.glb'].visible = false;
        out.models['zhen_30.glb'].visible = false;
        out.models['aijiu.glb'].visible = false;
        out.models['dian_2.glb'].visible = true;
    }
    changeState(index, options)
    {
        let state = null;
        if( index == 1) {
           state = new ResultState(this, options);
        }
        if( index == 0 ) {
            state =  new PlaceState(this, options);
        }
        if( index == 2) {
            state = new UnplaceState(this, options);
        }

        if( this.currState ) {
            this.currState.exit();
        }
        state.enter();
        this.currState = state;
    }

    onClickCanvas(event){
        let mouse = this.mouse;
        let w = this.el.clientWidth;
        let h = this.el.clientHeight;
        mouse.x = ( event.clientX / w ) * 2 - 1;
        mouse.y = - ( event.clientY / h ) * 2 + 1;

        this.currState && this.currState.onClick && this.currState.onClick( event );
    }

    onDocumentMouseMove(event)
    {
        if( !this.enable ) return;
        if( !this.el ) return;

        let mouse = this.mouse;
        let w = this.el.clientWidth;
        let h = this.el.clientHeight;
        mouse.x = ( event.clientX / w ) * 2 - 1;
        mouse.y = - ( event.clientY / h ) * 2 + 1;
    }

    setRentiRotate(name) {
        if( name == 'up' ) {
            this.activeCamera.position.set(0.007503259302513804, 0.4857151613772424, -1.9418360073176257)
            this.controls.spherical.theta = -3.140323936076204;
        } else {
            this.activeCamera.position.set(0.24121137628032507,0.35594009700832907,1.9549491848899296)
            this.controls.spherical.theta = -3.140323936076204;
        }
    }

    
    loadJiemao(){
        const loader = new THREE.GLTFLoader();
        loader.setCrossOrigin('anonymous');
        loader.load(prefix + './jiemao.glb', (gltf) => {
           const scene = gltf.scene || gltf.scenes[0];
           this.jiemao = scene;
           this.scene.add( scene );
           
        //    let textureLoader = new THREE.TextureLoader();
        //    let alphamap = textureLoader.load( prefix + './mei.jpg' );
        // //    alphamap.anisotropy = 4;
        //    alphamap.wrapS = alphamap.wrapT = THREE.RepeatWrapping;
        //    alphamap.format = THREE.RGBFormat;
           let pos = null;
           scene.traverse(node=>{
                if(node.isMesh) {
                    console.log("jiemao");
                    console.log( node.material );
                    node.material.transparent = true;
                    node.material.alphaMap = node.material.map;
                    node.material.map = null;
                    node.material.side = THREE.DoubleSide;
                    node.material.color.set(0,0,0);
                    // node.material.writeDepth = false;
                    pos = node.getWorldPosition();
                }
            });
            this.jiemaoPos = pos;
        });
    }

    setContent ( object ) {
        
        let XueWeiNames = { XueWei_DaChangYu:'dachangyu2',
                            XueWei_QiMen:"qimen",
                            XueWei_SanYinJiao:"sanyinjiao2",
                            XueWei_TaiChong:"taichong2",
                            XueWei_TianShu:"tianshu",
                            XueWei_ShenQue:"shenque",
                            XueWei_ShangJuXu:"shangjuxu2",
                            XueWei_QiMen_2you:'qimen2',
                            XueWei_TianShu_2you:'tianshu2',
                            XueWei_DaChangYu_2zuo:'dachangyu',
                            XueWei_ShangJuXu_2zuo:'shangjuxu',
                            XueWei_SanYinJiao_2zuo:'sanyinjiao',
                            XueWei_TaiChong_2zuo:'taichong'
                        };

        this.xueweis = {};
        object.traverse(node=>{
            if( node.isMesh ) {
                if( node.name.indexOf('XueWei') == 0) {
                    node.visible = false;
                    this.xueweis[XueWeiNames[node.name] ] = node;
                }
            }
        });
        console.log( this.xueweis );

        const box = new THREE.Box3().setFromObject(object);
        const size = box.getSize(new THREE.Vector3()).length();
        const center = box.getCenter(new THREE.Vector3());
    
        this.controls.reset();
    
        object.position.x += (object.position.x - center.x);
        object.position.y += (object.position.y - center.y);
        object.position.z += (object.position.z - center.z);

        // this.jiemao.position.copy( object.position );

        this.controls.maxDistance = size * 10;
        this.defaultCamera.near = size / 100;
        this.defaultCamera.far = size * 100;
        this.defaultCamera.updateProjectionMatrix();
    
        this.defaultCamera.position.copy(center);
        this.defaultCamera.position.x += size / 2.0;
        this.defaultCamera.position.y += size / 5.0;
        this.defaultCamera.position.z += size / 2.0;
        this.defaultCamera.lookAt(center);
    
        this.controls.saveState();
    
        this.scene.add(object);

        this.content = object;

        window.controls = this.controls;
    }

    animate (time) {

        this.loopid = requestAnimationFrame( this.animate );
        
        const dt = (time - this.prevTime) / 1000;
        
        this.controls.update();
        // this.stats.update();
        // this.mixer && this.mixer.update(dt);
        this.render();
        
        this.prevTime = time;
    }
        
    render () {

        this.currState && this.currState.update();

        // this.check();

        this.renderer.render( this.scene, this.activeCamera );

        
        // this.renderer.render( this.scene2, this.activeCamera);
    }
        
    resize () {
        const {clientHeight, clientWidth} = this.el;
        this.defaultCamera.aspect = clientWidth / clientHeight;
        this.defaultCamera.updateProjectionMatrix();
        // this.background.style({aspect: this.defaultCamera.aspect});
        this.renderer.setSize(clientWidth, clientHeight);
    }
    
    changeLieType( type ) {
        console.log( type );
        if( type == 0 ) //仰 
        {
            this.setRentiRotate('up');
            return;
        }
        this.setRentiRotate('down');
    }

    placeYinzhen(para){
        this.currState && this.currState.placeYinzhen(para);
    }

    placeAijiu(para){
        this.currState && this.currState.placeAijiu(para);
    }
}

export default new Demo();


